import { Component, OnInit } from '@angular/core';
import {
  AgGridComponentFrameworkComponent
} from "../../../../../shared/components/ag-grid/ag-grid-component-framework/ag-grid-component-framework.component";
import {CellSourceComponent} from "../../../../../shared/components/cell-source/cell-source.component";
import {Serializer} from "../../../../../shared/interfaces/serializer";
import {DataSetMetric} from '../../../../../shared/interfaces/metrics';
import {CellSelectComponent} from "../../../../../shared/components/cell-select/cell-select.component";
import {CellSourcesComponent} from "../../../../../shared/components/cell-sources/cell-sources.component";
import {TranslateService} from "@ngx-translate/core";
import {SelectOption} from "../../../../../shared/interfaces/form";
import {Visibility} from "../../../../../shared/interfaces/settings";
import {SettingsService} from "../../../../../shared/services/settings.service";
import {AppService} from "../../../../../shared/services/app.service";
import {AppState} from "../../../../../shared/store/store";
import {Store} from "@ngrx/store";
import {Observable} from "rxjs";
import {
  selectDataSetMetricNormalizedComponentObjects,
  selectDataSetMetricsLoading
} from '../../../../../shared/store/dataSetMetrics/dataSetMetrics.selectors';
import {updateDataSetMetric} from '../../../../../shared/store/dataSetMetrics/dataSetMetrics.actions';
import {MetricComponentObject, MetricComponentObjects} from '../../../../../shared/classes/metric-component-object';

@Component({
  selector: 'app-metrics-normalized-table',
  templateUrl: './metrics-normalized-table.component.html',
  styleUrls: ['./metrics-normalized-table.component.scss']
})
export class MetricsNormalizedTableComponent implements OnInit {
  public readonly normalizedColumnDefs: Array<any> = [
    {
      field: 'metric',
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
      lockPosition: true,
      headerValueGetter: _ => this._translateS.instant('settings.metric'),
      valueGetter: params => params.data.payload.attributes.name,
      filterValueGetter: params => params.data.payload.attributes.name,
      cellRendererFramework: AgGridComponentFrameworkComponent,
      cellRendererParams: _ => {
        return {
          component:  CellSourceComponent,
          componentParams: {
            sourceGetter: (row: Serializer<DataSetMetric>) => row,
          }
        };
      }
    },
    {
      field: 'visibility',
      minWidth: 200,
      sortable: true,
      lockPosition: true,
      filter: true,
      tooltipComponent: 'customTooltip',
      headerTooltip: this._translateS.instant('settings.visibility_tooltip'),
      valueGetter: params => params.data.payload.attributes.visibility,
      headerValueGetter: _ => this._translateS.instant('settings.visibility'),
      cellRendererFramework: AgGridComponentFrameworkComponent,
      cellRendererParams: _ => {
        return {
          component:  CellSelectComponent,
          componentParams: this._getVisibilityParams()
        };
      },
      filterValueGetter: params => this._translateS.instant(`settings.${params.data.payload.attributes.visibility}`)
    },
    {
      field: 'sources',
      minWidth: 200,
      sortable: false,
      filter: false,
      lockPosition: true,
      suppressMenu: true,
      headerValueGetter: _ => this._translateS.instant('settings.sources'),
      valueGetter: params => params.data.payload.attributes.name,
      filterValueGetter: params => params.data.payload.attributes.name,
      cellRendererFramework: AgGridComponentFrameworkComponent,
      cellRendererParams: _ => {
        return {
          component:  CellSourcesComponent,
          componentParams: {}
        };
      }
    }
  ];

  public readonly defaultColDef: any = {
    resizable: true,
    suppressNavigable: true,
    suppressCellSelection: true,
    menuTabs: ['filterMenuTab'],
    filterParams: {
      buttons: ['reset']
    }
  };

  public readonly metrics$: Observable<MetricComponentObjects> = this._store.select(selectDataSetMetricNormalizedComponentObjects);
  public readonly loading$: Observable<boolean> = this._store.select(selectDataSetMetricsLoading);

  constructor(
    private readonly _translateS: TranslateService,
    private readonly _settingsS: SettingsService,
    private readonly _appS: AppService,
    private readonly _store: Store<AppState>
  ) { }

  ngOnInit(): void {}

  private _getVisibilityParams(): any {
    return {
      options:            this._settingsS.visibilities,
      disabled:           this._appS.isNotDatasetAdmin,
      defaultValueGetter: (metric: MetricComponentObject) => (metric.payload.attributes as DataSetMetric).visibility,
      textGetter:         (visibility: SelectOption<Visibility, string>) => visibility.text,
      valueGetter:        (visibility: SelectOption<Visibility, string>) => visibility.key,
      onValueChanges:     (row: any, value: any) => this._updateMetric(row, value)
    };
  }

  private _updateMetric(metric: MetricComponentObject, visibility: Visibility): void {
    this._store.dispatch(updateDataSetMetric({
      metric: metric.payload as Serializer<DataSetMetric>,
      update: {
        visibility: visibility
      }
    }));
  }

}
